import langData from './zh-CN.json'
const locaLangData = {
  login: {
    readMarketing: '我同意根据',
    readMarketingAfter: '接收相关的 SGS 更新和活动邀请。',
    agreedBtn: '我已阅读并同意',
    title: '登录 ',
    info: '微服务开发平台',
    tenantId: '请输入租户ID',
    username: '请输入注册邮箱或手机号',
    password: '请输入密码',
    rePassword: '请重复输入密码',
    passwordValidate: {
      lengthValidate: '密码长度最少为6位',
    },
    loginFailed: '登录失败',
    needInvidUpdate: '接收相关的SGS更新和活动邀请',
    wechat: '微信',
    qq: 'QQ',
    phone: '请输入手机号',
    code: '请输入验证码',
    submit: '登录',
    toRegister: '注册',
    forgetPassword: '忘记密码',
    userLogin: '账号密码',
    phoneLogin: '手机号登录',
    thirdLogin: '第三方登录',
    msgText: '发送验证码',
    msgSuccess: '秒后重发',
    readAgree: '我已阅读并同意 ',
    serviceTrems: 'SGS 使用条款',
    serviceTremsEnd: '。',
    agreeServiceTerms: '请阅读并同意SGS服务条款和条件',
  },
  agreement: {
    agreeAndContinue: '同意并继续',
    privacyPolicy: 'SGS SMART 隐私声明',
    useConditions: '注册条款',
  },
}
export default { ...locaLangData, ...langData } as Record<string, any>
